import { render } from "./eatDesktimeOrder.vue?vue&type=template&id=e91f23b2"
import script from "./eatDesktimeOrder.vue?vue&type=script&lang=js"
export * from "./eatDesktimeOrder.vue?vue&type=script&lang=js"

import "./eatDesktimeOrder.vue?vue&type=style&index=0&id=e91f23b2&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__